export const rightChevron = `\u203A`;
export const bullet = `\u2022`;
